export const confirmAppointmentLoading = ({store}) => store.confirmAppointmentReducer.loading;

export const confirmAppointmentError =  ({store})  => store.confirmAppointmentReducer.error;

export const confirmAppointmentData =  ({store})  => store.confirmAppointmentReducer.data;